import Immutable from 'immutable';
import {
  FLAG_GETTING_CREW_STATUSES,
  GET_CREW_STATUSES,
  CLEAR_CREW_STATUSES,
  FLAG_CREW_STATUS_ACTIVITY,
  CLEAR_CREW_STATUS,
  GET_CREW_STATUS,
} from '../../../actions/types/traffic';
import { COLLECTION_SHAPE } from '../../../config/shapes';

const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
  current: Immutable.Map({
    content: Immutable.Map(),
    activity: Immutable.List(),
  }),
});

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case FLAG_GETTING_CREW_STATUSES:
      return state.setIn(['all', 'loading'], payload);
    case GET_CREW_STATUSES:
      return state.setIn(['all', 'content'], Immutable.Map(payload));
    case CLEAR_CREW_STATUSES:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['all', 'content']),
      );
    case FLAG_CREW_STATUS_ACTIVITY:
      if (payload) {
        return state.setIn(
          ['current', 'activity'],
          state.getIn(['current', 'activity']).push(payload),
        );
      }

      return state.setIn(
        ['current', 'activity'],
        state.getIn(['current', 'activity']).pop(),
      );
    case GET_CREW_STATUS:
      return state.setIn(['current', 'content'], Immutable.Map(payload));
    case CLEAR_CREW_STATUS:
      return state.setIn(['current'], INITIAL_STATE.getIn(['current']));
    default:
      return state;
  }
};
